import {
  CustomFontSettings,
  FontAttributes,
  GoogleFontSettings,
} from '@loyalty/shared-common/template-api-client';

export function getCssImportFont(font: FontAttributes): string {
  return `@import '${(font.settings as GoogleFontSettings).link}';`;
}

export function getFontFace(font: FontAttributes): string {
  return Object.entries(font.settings as CustomFontSettings)
    .map(
      ([format, url]) =>
        `@font-face {
  font-family: '${font.name}';
  font-display: swap;
  src: url('${url}'); format('${format}');
}`,
    )
    .join('\n');
}
